import { orange as t, green as g, red as i, blue as r, graphite as e, whiteAlfa as a, graphiteAlfa as n } from "./index3.mjs";
const c = {
  background: e.graphite50,
  paper: a.whiteAlfa900,
  primary: a.whiteAlfa900,
  secondary: e.graphite50,
  modal: e.graphite50,
  modalInverted: e.graphite900,
  opacity90: a.whiteAlfa800,
  opacityFixed8: a.whiteAlfa50,
  lightFixed: a.whiteAlfa900,
  accent: r.blue500,
  onAccent: r.blue400,
  accentPale: r.blue100,
  success: g.green500,
  warning: t.orange500,
  negative: i.red500
}, o = {
  background: e.graphite950,
  paper: e.graphite900,
  primary: e.graphite850,
  secondary: e.graphite800,
  modal: e.graphite900,
  modalInverted: e.graphite50,
  opacity90: n.graphiteAlfa800,
  opacityFixed8: a.whiteAlfa50,
  lightFixed: a.whiteAlfa900,
  accent: r.blue400,
  onAccent: r.blue500,
  accentPale: e.graphite850,
  success: g.green400,
  warning: t.orange400,
  negative: i.red400
}, l = {
  primary: e.graphite900,
  primaryInverted: e.graphite10,
  secondary: e.graphite700,
  tertiary: e.graphite400,
  accent: r.blue600,
  success: g.green600,
  warning: t.orange600,
  negative: i.red600,
  lightFixed: e.graphite10,
  lightFixed70: a.whiteAlfa600,
  darkFixed: e.graphite900
}, b = {
  primary: e.graphite10,
  primaryInverted: e.graphite900,
  secondary: e.graphite400,
  tertiary: e.graphite600,
  accent: r.blue400,
  success: g.green400,
  warning: t.orange400,
  negative: i.red400,
  lightFixed: e.graphite10,
  lightFixed70: a.whiteAlfa600,
  darkFixed: e.graphite900
}, s = {
  divider: e.graphite50,
  border: e.graphite200,
  accent: r.blue500,
  negative: i.red500,
  lightFixed: a.whiteAlfa900,
  lightFixed12: a.whiteAlfa100
}, h = {
  divider: e.graphite800,
  border: e.graphite700,
  accent: r.blue400,
  negative: i.red400,
  lightFixed: a.whiteAlfa900,
  lightFixed12: a.whiteAlfa100
}, p = {
  icotexDisable: e.graphite300,
  accentAction: r.blue700,
  accentPaleAction: r.blue200,
  successAction: g.green700,
  warningAction: t.orange700,
  negativeAction: i.red700,
  lightFixedAction: a.whiteAlfa800,
  actionDisabled: e.graphite100,
  actionPressed: e.graphite100,
  mainInverted70: "rgba(67, 76, 91, 0.7)"
}, F = {
  icotexDisable: e.graphite600,
  accentAction: r.blue500,
  accentPaleAction: e.graphite800,
  successAction: g.green500,
  warningAction: t.orange500,
  negativeAction: i.red500,
  lightFixedAction: a.whiteAlfa800,
  actionDisabled: e.graphite800,
  actionPressed: e.graphite800,
  mainInverted70: "rgba(57, 62, 72, 0.7)"
}, m = {
  brandPrimary: "#193FD6",
  brandSecondary: "#E42CA3",
  brandTertiary: "#DE0056",
  brandQuaternary: "#A8FF00",
  logoPrimary: "#193FD6",
  logoSecondary: "#E42CA3"
}, u = {
  brandPrimary: "#193FD6",
  brandSecondary: "#E42CA3",
  brandTertiary: "#DE0056",
  brandQuaternary: "#A8FF00",
  logoPrimary: "#FFFFFF",
  logoSecondary: "#FFFFFF"
}, f = {
  accent: {
    from: r.blue500,
    to: r.blue200,
    css: `linear-gradient(83deg,${r.blue500} 0%, ${r.blue200} 100%)`
  },
  accentDark: {
    from: r.blue500,
    to: r.blue300,
    css: `linear-gradient(63deg, ${r.blue500} 0%, ${r.blue300} 98.43%)`
  },
  pulse: {
    from: i.red500,
    to: i.red200,
    css: `linear-gradient(83deg, ${i.red500} 0%, ${i.red200} 100%)`
  },
  flow: {
    from: g.green500,
    to: g.green200,
    css: `linear-gradient(83deg, ${g.green500} 0%, ${g.green200} 100%)`
  },
  sunshine: {
    from: t.orange500,
    to: t.orange200,
    css: `linear-gradient(83deg, ${t.orange500} 0%, ${t.orange200} 100%)`
  },
  depth: {
    from: "#BA52DF",
    to: "#E193FD",
    css: "linear-gradient(83deg, #BA52DF 0%, #E193FD 100%)"
  },
  muse: {
    from: "#FB5C79",
    to: "#FC8FB7",
    css: "linear-gradient(83deg, #FB5C79 0%, #FC8FB7 100%)"
  },
  edge: {
    from: "#F80FEE",
    to: "#FE84F9",
    css: "linear-gradient(83deg, #F80FEE 0%, #FE84F9 100%)"
  }
}, A = {
  accent: {
    from: "rgba(51, 99, 247, 0)",
    mid: "rgba(51, 99, 247, 0.4)",
    to: "rgba(51, 99, 247, 1)",
    css: "linear-gradient(180deg, rgba(51, 99, 247, 0) 0%, rgba(51, 99, 247, 0.4) 56%, rgba(51, 99, 247, 1) 100%)"
  },
  accentDark: {
    from: "rgba(15, 44, 187, 0)",
    mid: "rgba(15, 44, 187, 0.4)",
    to: "rgba(15, 44, 187, 1)",
    css: "linear-gradient(180deg, rgba(15, 44, 187, 0) 0%, rgba(15, 44, 187, 0.4) 56%, rgba(15, 44, 187, 1) 100%)"
  },
  pulse: {
    from: "rgba(220, 0, 17, 0)",
    mid: "rgba(220, 0, 17, 0.4)",
    to: "rgba(220, 0, 17, 1)",
    css: "linear-gradient(180deg, rgba(220, 0, 17, 0) 0%, rgba(220, 0, 17, 0.4) 56%, rgba(220, 0, 17, 1) 100%)"
  },
  flow: {
    from: "rgba(0, 157, 62, 0)",
    mid: "rgba(0, 157, 62, 0.4)",
    to: "rgba(0, 157, 62, 1)",
    css: "linear-gradient(180deg, rgba(0, 157, 62, 0) 0%, rgba(0, 157, 62, 0.4) 56%, rgba(0, 157, 62, 1) 100%)"
  },
  sunshine: {
    from: "rgba(245, 122, 41, 0)",
    mid: "rgba(245, 122, 41, 0.4)",
    to: "rgba(245, 122, 41, 1)",
    css: "linear-gradient(180deg, rgba(245, 122, 41, 0) 0%, rgba(245, 122, 41, 0.4) 56%, rgba(245, 122, 41, 1) 100%)"
  },
  depth: {
    from: "rgba(186, 82, 223, 0)",
    mid: "rgba(186, 82, 223, 0.4)",
    to: "rgba(186, 82, 223, 1)",
    css: "linear-gradient(180deg, rgba(186, 82, 223, 0) 0%, rgba(186, 82, 223, 0.4) 56%, rgba(186, 82, 223, 1) 100%)"
  },
  muse: {
    from: "rgba(251, 92, 121, 0)",
    mid: "rgba(251, 92, 121, 0.4)",
    to: "rgba(251, 92, 121, 1)",
    css: "linear-gradient(180deg, rgba(251, 92, 121, 0) 0%, rgba(251, 92, 121, 0.4) 56%, rgba(251, 92, 121, 1) 100%)"
  },
  edge: {
    from: "rgba(248, 15, 238, 0)",
    mid: "rgba(248, 15, 238, 0.4)",
    to: "rgba(248, 15, 238, 1)",
    css: "linear-gradient(180deg, rgba(248, 15, 238, 0) 0%, rgba(248, 15, 238, 0.4) 56%, rgba(248, 15, 238, 1) 100%)"
  }
};
export {
  u as brandDark,
  m as brandLight,
  f as gradient,
  b as icotextDark,
  l as icotextLight,
  F as interactDark,
  p as interactLight,
  h as outlineDark,
  s as outlineLight,
  A as overlay,
  o as surfaceDark,
  c as surfaceLight
};
